module.exports = __webpack_public_path__ + "static/media/icon-call-no.fe5fdc86.svg";